import React from 'react';
import { Button } from '@/shared/ui/button';
import { DialogHeader, DialogTitle } from '@/shared/ui/dialog';
import btnIcons from '@/shared/assets/sprites/btns.sprite.svg';
import type { DialogHeaderProps } from '../model/types';
export const PhoneDialogHeader: React.FC<DialogHeaderProps> = ({
  title,
  onClose
}) => <DialogHeader data-sentry-element="DialogHeader" data-sentry-component="PhoneDialogHeader" data-sentry-source-file="PhoneDialogHeader.tsx">
    <DialogTitle className="relative min-h-10" data-sentry-element="DialogTitle" data-sentry-source-file="PhoneDialogHeader.tsx">
      {title && <span className="mx-auto max-w-64 text-balance text-center text-base font-bold">{title}</span>}
      <Button variant="circle" className="absolute right-0 top-0 size-10 bg-bgSecondary" onClick={onClose} data-sentry-element="Button" data-sentry-source-file="PhoneDialogHeader.tsx">
        <svg className="size-10 rotate-180 stroke-textPrimary" data-sentry-element="svg" data-sentry-source-file="PhoneDialogHeader.tsx">
          <use xlinkHref={`${btnIcons}#close`} data-sentry-element="use" data-sentry-source-file="PhoneDialogHeader.tsx"></use>
        </svg>
      </Button>
    </DialogTitle>
  </DialogHeader>;